module.exports = __webpack_public_path__ + "static/media/map-pin.29e8e261.svg";